import redirectInterceptor from "@/interceptors/redirect_interceptor";

const getDefaultState = () => {
  return {
    overconsumptionData: null,
    overconsumptionDataLoading: true,
    overconsumptionDataError: null,
  };
};

const state = getDefaultState();

const getters = {
  displayOverconsumption(state) {
    try {
      return state.overconsumptionData.cons_cumsum.toFixed(3);
    } catch (error) {
      return "-";
    }
  },
  displayCompleteness(state) {
    try {
      return state.overconsumptionData.completeness.toFixed(2);
    } catch (error) {
      return "-";
    }
  },

};

const actions = {
  async fetchOverconsumptionData({ commit }, payload) {
    const basicUrl = localStorage.getItem("basicUrl");
    const vesselName = payload.name;
    const startDate = payload.startDate;
    const stopDate = payload.stopDate;
    commit("SET_FETCH_OVERCONSUMPTION_DATA_LOADING_STATE");

    const response = await redirectInterceptor.get(`${basicUrl}/vesselInformation/${vesselName}/voyageCleanData`, {
      params: {
        startDate: startDate,
        stopDate: stopDate
      },
      headers: {
        Authorization: localStorage.getItem("quad_token")
      }
    });
    if (response.status === 200) {
      commit("SET_FETCH_OVERCONSUMPTION_DATA_SUCCESS_STATE", response.data);
    }
    else {
      commit("SET_FETCH_OVERCONSUMPTION_DATA_ERROR_STATE");
    }
  }
};

const mutations = {
  SET_FETCH_OVERCONSUMPTION_DATA_LOADING_STATE(state) {
    state.overconsumptionDataLoading = true;
  },
  SET_FETCH_OVERCONSUMPTION_DATA_ERROR_STATE(state) {
    state.overconsumptionDataLoading = false;
    state.overconsumptionDataError = "Could not fetch overconsumption data";
  },
  SET_FETCH_OVERCONSUMPTION_DATA_SUCCESS_STATE(state, data) {
    state.overconsumptionDataLoading = false;
    state.overconsumptionDataError = null;
    state.overconsumptionData = data;
  },
};

export const overconsumptionModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
